/** Indonesian content of `/tutorial`. Team Build and package instructions verified on 13 Sep 2026 against docs/team-build/USER_GUIDE.md and package command definitions; earlier paths: docs/tutorial/RISET_TUTORIAL.md. Chapter `bedah` (website dissection) checked on 24 Sep 2026 against src/lib/site/* and docs/reverse-engineering/PLAN.md. */
import { CMD } from './tutorial-commands'
import type { TutorialContent } from './tutorial-types'

export const TUTORIAL_ID: TutorialContent = {
  hero: {
    overline: 'Tutorial',
    title: 'Tutorial lengkap Bystep, semua mode, langkah demi langkah',
    lead: 'Dari membuat akun sampai aplikasi terbukti jalan. Pilih jalurmu: Bystep yang membangun, kamu sendiri dengan CLI, atau komputermu sendiri dengan langganan AI yang sudah kamu bayar. Untuk founder dan developer yang bekerja bersama, ikuti bab Team Build.',
    meta: 'CLI 0.7.0 · MCP 0.5.0 · Bystep Desktop 0.2.0 (Linux) · diperbarui 13 September 2026',
  },
  tocTitle: 'Isi tutorial',
  paths: [
    {
      id: 'otomatis',
      badge: 'Jalur A',
      title: 'Bangunkan untuk saya',
      who: 'Pemilik usaha, kreator, pengajar. Tidak perlu memasang apa pun.',
      bullets: ['Bystep yang mengerjakan langkahnya', 'Kamu menyetujui tiap tahap', 'Coba dulu di HP, lalu Terbitkan'],
    },
    {
      id: 'mandiri',
      badge: 'Jalur B',
      title: 'Mandiri dengan CLI',
      who: 'Developer yang sudah punya agen koding dan folder proyek sendiri.',
      bullets: ['Satu task per permintaan', 'Bukti dulu, baru boleh selesai', 'Bisa lewat CLI atau MCP'],
    },
    {
      id: 'komputer',
      badge: 'Jalur C',
      title: 'Komputer saya',
      who: 'Punya langganan Claude Pro/Max atau ChatGPT dan ingin memakainya.',
      bullets: ['Komputermu yang mengerjakan', 'Jatah langkah Bystep tidak terpakai', 'Bystep tetap memegang rencana dan bukti'],
    },
  ],
  extras: [
    { id: 'bedah', title: 'Bedah website', text: 'Tempel alamat situs acuan; Bystep membedahnya lalu mewawancaraimu sebelum menulis PRD.' },
    { id: 'team-build', title: 'Team Build: tim 2–10 orang', text: 'Bagi tugas, pakai AI masing-masing, lalu pantau bukti, review, dan catatan rilis.' },
    { id: 'tim', title: 'Tim agent paralel', text: 'Beberapa langkah mandiri sekaligus, tiap bagian di folder sendiri.' },
    { id: 'kolaborasi', title: 'Design Room & portal klien', text: 'Rumuskan bareng tim, lalu beri klien tampilan baca-saja.' },
    { id: 'mcp', title: 'MCP', text: 'Kendalikan Bystep dari Claude Code, Codex, Cursor, atau Claude.ai.' },
  ],
  sections: {
    pilih: {
      overline: 'Langkah 0',
      title: 'Pilih jalur yang cocok',
      lead: 'Bystep punya satu rencana dan banyak cara mengerjakannya. Bagian rencana (Bagian 1) sama untuk semua orang; setelah itu kamu memilih siapa yang mengetik kodenya.',
      intro: [
        {
          kind: 'table',
          head: ['Kalau kamu…', 'Mulai dari'],
          rows: [
            ['tidak menulis kode dan ingin aplikasinya jadi', 'Jalur A — Bangunkan untuk saya'],
            ['developer, sudah pakai Claude Code / Cursor / Codex', 'Jalur B — Mandiri dengan CLI'],
            ['sudah bayar langganan Claude atau ChatGPT dan ingin memakainya', 'Jalur C — Komputer saya'],
            ['founder dan developer 2–10 orang yang memakai AI masing-masing', 'Team Build — build bersama tim'],
            ['ingin beberapa langkah dikerjakan sekaligus', 'Tim agent (butuh Jalur B atau C dulu)'],
            ['ingin merumuskan ide bersama tim atau klien', 'Design Room'],
            ['punya situs acuan (pesaing, inspirasi, atau situs lamamu) yang ingin dibedah dulu', 'Bedah website, lalu lanjut ke jalur mana pun'],
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          title: 'Jalur bisa dicampur',
          text: 'Satu rencana yang sama bisa dikerjakan Bystep hari ini dan dilanjutkan di komputermu besok. Yang berpindah hanya "siapa yang mengerjakan"; rencana, bukti, dan persetujuan tetap di tempatnya.',
        },
      ],
    },

    dasar: {
      overline: 'Persiapan',
      title: 'Dasar yang perlu kamu tahu dulu',
      lead: 'Lima menit di sini menghemat banyak kebingungan nanti: akun, dua tampilan, kuota, dan kosakata.',
      steps: [
        {
          title: 'Buat akun',
          blocks: [
            { kind: 'p', text: 'Buka bystep.dev, tekan Mulai gratis, lalu Lanjut dengan Google. Tombol yang sama sekaligus membuat akun baru — tidak ada formulir kata sandi terpisah.' },
            { kind: 'p', text: 'Akun baru melewati tiga layar perkenalan: nama, tahu Bystep dari mana, dan "Mana yang paling menggambarkan kamu?". Jawaban terakhir menentukan tampilanmu.' },
          ],
        },
        {
          title: 'Pilih tampilan: mode developer atau mode sederhana',
          blocks: [
            {
              kind: 'table',
              head: ['', 'Mode developer (bawaan)', 'Mode sederhana'],
              rows: [
                ['Cara masuk', 'default', 'pilih "Saya bukan programmer" saat perkenalan, atau Pengaturan → Nyalakan mode sederhana'],
                ['Pertanyaan klarifikasi', 'sampai 3 putaran (3–6 per putaran), disusun untuk idemu', '1 putaran isi 3'],
                ['Isi PRD', '10 bagian', '5 bagian, bahasa sehari-hari'],
                ['Pilihan teknologi', 'ada', 'dilewati (Stack Baku)'],
                ['Tab di proyek', 'Wiki · Tasks · Biaya · Tim · Studio', 'Rencana · Bangun · Terbitkan · Bantuan'],
                ['Istilah', 'PRD, task, fase', 'Rencana, Langkah, Tahap'],
              ],
            },
            { kind: 'p', text: 'Mode bisa diganti kapan saja di Pengaturan; rencana yang sudah ada tidak hilang.' },
          ],
        },
        {
          title: 'Pahami jatah gratis',
          blocks: [
            {
              kind: 'list',
              items: [
                'Gratis: 1 PRD per bulan dan 5 pesan Bystep Agent per bulan.',
                'Langkah yang dikerjakan Bystep (Runner) punya jatah tersendiri per bulan, tergantung paket.',
                'Langkah yang gagal tidak memotong jatah.',
                'Memakai template tidak memotong jatah PRD.',
              ],
            },
            { kind: 'note', tone: 'info', title: 'Angka selalu di satu tempat', text: 'Harga dan batas terbaru ada di halaman Harga. Kalau angka di halaman itu berbeda dengan yang kamu ingat, halaman Harga yang benar.' },
          ],
        },
        {
          title: 'Kenali kosakatanya',
          blocks: [
            {
              kind: 'table',
              head: ['Mode sederhana', 'Mode developer', 'Artinya'],
              rows: [
                ['Rencana', 'PRD', 'dokumen sumber kebenaran proyek'],
                ['Langkah', 'Task', 'satu pekerjaan dengan kriteria terima; verifikasi mesin atau review manual sesuai kriterianya'],
                ['Tahap', 'Fase', 'kumpulan langkah yang berakhir di gerbang persetujuan'],
                ['Bukti', 'Evidence', 'hasil menjalankan kriteria terima — bukan pendapat AI'],
                ['Kunci AI', 'API key', 'kunci API milikmu sendiri, bukan login akun'],
                ['Komputer saya', 'bystep serve', 'komputermu yang menjalankan agen'],
                ['Pemeriksa', 'Reviewer agent', 'agen baca-saja yang memberi temuan Critical/Major/Minor'],
              ],
            },
          ],
        },
      ],
    },

    rencana: {
      overline: 'Bagian 1 — untuk semua orang',
      title: 'Dari ide jadi rencana yang bisa dikerjakan',
      lead: 'Semua jalur mulai dari sini. Hasil akhirnya: PRD, peta fitur, dan daftar task yang tiap task-nya punya kriteria terima.',
      steps: [
        {
          title: 'Mulai rencana baru',
          blocks: [
            { kind: 'p', text: 'Dari beranda tekan Rencanakan, lalu pilih Dari ide. (Sudah punya kode? Pilih Dari codebase — Bystep akan meminta agenmu memindai repo dulu. Ingin berangkat dari situs yang sudah ada? Pilih Bedah website — lihat Bagian 1b.)' },
          ],
        },
        {
          title: 'Tulis idemu',
          blocks: [
            { kind: 'p', text: 'Tulis 2–3 kalimat: untuk siapa, masalah apa, hasil seperti apa. Minimal 20 karakter. Enter langsung mengirim, Shift+Enter untuk baris baru.' },
            { kind: 'p', text: 'Di baris bawah kotak ide kamu bisa memilih Bahasa dokumen (Indonesia/English) dan — di mode developer — model AI.' },
            { kind: 'note', tone: 'ok', title: 'Tidak mau mulai dari kosong?', text: 'Halaman Template berisi rencana nyata yang sudah punya minimal 5 task terverifikasi, dan memakainya tidak memotong jatah PRD. Halaman Playbook berisi resep siap pakai untuk warung, bimbel, notaris, koperasi, klinik, dan yayasan/masjid.' },
          ],
        },
        {
          title: 'Tentukan teknologi (mode developer)',
          blocks: [
            { kind: 'p', text: 'Pilih Biar AI pilih, atau Pilih sendiri untuk menentukan Frontend, Backend, Database, dan Deployment. Mode sederhana melewati langkah ini dan memakai Stack Baku.' },
          ],
        },
        {
          title: 'Jawab pertanyaan klarifikasi',
          blocks: [
            { kind: 'p', text: 'Bystep mewawancaraimu bertahap. Ia membaca ide dan dokumen referensimu dulu lalu mencantumkan yang sudah ditemukan (fakta itu tidak ditanya), kemudian hanya menanyakan keputusan yang tidak bisa ia ambil untukmu: 3 sampai 6 pertanyaan per putaran, masing-masing dengan judul singkat, alasan kenapa penting, dan jawaban rekomendasi yang bisa kamu terima dengan satu klik. Jawabanmu membuka putaran berikutnya, maksimal tiga putaran di mode developer; mode sederhana hanya satu putaran berisi 3 pertanyaan sederhana.' },
            { kind: 'p', text: 'Tiap kartu punya tombol Lewati, dan chip Lainnya untuk menambah pilihanmu sendiri. Pakai semua rekomendasi mengisi pertanyaan yang masih kosong di putaran itu; Salin sebagai kuesioner memberimu berkas Markdown untuk dikirim ke pemegang jawabannya; Ulangi pertanyaan dari awal membuang wawancara. Tanya putaran berikutnya butuh putaran ini dijawab atau dilewati; Cukup, susun rencana selalu tersedia begitu semua dijawab atau dilewati. Saat tidak ada lagi yang perlu ditanya, Bystep menampilkan pemahaman bersama yang jadi dasar PRD.' },
          ],
        },
        {
          title: 'Baca draft PRD',
          blocks: [
            { kind: 'p', text: 'Bystep menulis PRD lalu berhenti di halaman review: dokumen di kiri, Bystep Agent di kanan. PRD mode developer punya 10 bagian — Overview, Requirements, Core Features, User Flow, Architecture, Database Schema, Tech Stack, Goals & Success Metrics, Risks, dan Milestones. Mode sederhana 5 bagian.' },
            { kind: 'note', tone: 'warn', title: 'Tulis ulang PRD memakai kuota', text: 'Tombol Tulis ulang PRD membuang revisi dari chat dan memakai satu jatah rencana. Untuk perubahan kecil, pakai Ubah atau minta lewat chat.' },
          ],
        },
        {
          title: 'Revisi lewat Bystep Agent',
          blocks: [
            { kind: 'p', text: 'Minta perubahan dengan bahasa biasa, misalnya "tambahkan absensi guru" atau "buang fitur pembayaran dulu". Agent menulis ulang PRD, lalu menyodorkan usulan penyelarasan fitur.' },
            { kind: 'p', text: 'Usulan dikelompokkan Ditambah / Diubah / Dihapus, dan kamu menekan Terapkan atau Tolak. Tidak ada yang ditimpa diam-diam.' },
          ],
        },
        {
          title: 'Susun fitur & task',
          blocks: [
            { kind: 'p', text: 'Tekan Susun fitur & task. Bystep memetakan fitur → sub-fitur, lalu menulis spesifikasi dan task. Di mode developer tiap fitur dipecah jadi 8–20 task.' },
            { kind: 'p', text: 'Task sengaja berlapis: task frontend dibangun di atas data tiruan dulu, baru backend (skema → API → realtime). Jadi kamu bisa mengklik UI sebelum satu baris backend pun ada.' },
          ],
        },
        {
          title: 'Kenali papan kerjamu',
          blocks: [
            {
              kind: 'table',
              head: ['Tampilan', 'Gunanya'],
              rows: [
                ['Roadmap', 'peta fitur per fase; bisa Peta atau Linimasa, bisa diekspor PNG/SVG/Mermaid'],
                ['Tasks', 'papan Kanban 4 kolom: Antre · Dikerjakan · Selesai · Gagal'],
                ['Wiki', 'dokumentasi codebase hasil sync, plus pemindaian Drift'],
                ['Biaya', 'token, durasi, dan biaya per task; bisa diekspor CSV'],
                ['Kesiapan', 'skor kesiapan proyek dan laporan bukti'],
              ],
            },
            { kind: 'p', text: 'Buka satu task untuk melihat kriteria terima, bukti, komentar, file yang dimiliki task itu, dan prompt siap salin.' },
          ],
        },
      ],
      outro: [
        {
          kind: 'note',
          tone: 'warn',
          title: 'Aturan yang tidak bisa ditawar',
          text: 'Task tidak bisa ditandai Selesai tanpa bukti yang lulus. Kalau dipaksa, server menolak dengan evidence_required. Satu-satunya jalan lain adalah override yang wajib disertai alasan, dan override itu tercatat di laporan.',
        },
      ],
    },

    bedah: {
      overline: 'Bagian 1b — mulai dari situs yang sudah ada',
      title: 'Bedah website: dari situs acuan jadi rencana milikmu',
      lead: 'Punya situs yang kamu kagumi, situs pesaing, atau situs lamamu sendiri? Tempel alamatnya. Bystep membaca halaman publiknya, menyusun hasil bedah berbukti, lalu mewawancaraimu untuk memutuskan versi milikmu — bukan menyalinnya.',
      steps: [
        {
          title: 'Buka Bedah website',
          blocks: [
            { kind: 'p', text: 'Dari beranda pilih kartu Bedah website, atau tekan Rencanakan lalu pilih Bedah website. Keduanya membuka /plan?flow=website.' },
          ],
        },
        {
          title: 'Isi formulirnya',
          blocks: [
            { kind: 'p', text: 'Alamat website: nama domain saja cukup (misalnya plane.so) atau alamat lengkap. Hanya situs publik lewat http/https di port standar; alamat IP, localhost, dan jaringan internal ditolak.' },
            { kind: 'p', text: 'Mau bikin apa? (opsional, maksimal 2.000 karakter): tulis arah versimu, misalnya "versi untuk UMKM Indonesia, bayar pakai QRIS, lebih sederhana dari aslinya". Catatan ini ikut membentuk draf ide dan wawancara.' },
            {
              kind: 'table',
              head: ['Hubunganmu dengan situs ini', 'Artinya'],
              rows: [
                ['Inspirasi', 'situs yang kamu kagumi'],
                ['Pesaing', 'kamu ingin lebih baik darinya'],
                ['Situs sendiri', 'dibangun ulang atau dimodernkan — wawancara menanyakan apa yang harus tetap sama untuk pengguna lama'],
                ['Situs klien', 'proyek untuk klienmu'],
              ],
            },
            { kind: 'p', text: 'Pilih Bahasa hasil (dan model AI di mode developer), centang pernyataan penggunaan, lalu tekan Bedah sekarang. Pernyataan itu wajib: hasil bedah hanya untuk analisis dan inspirasi, tanpa meniru merek, logo, teks, gambar, atau tampilan khas situs lain.' },
          ],
        },
        {
          title: 'Tunggu pembedahannya (biasanya 1–4 menit)',
          blocks: [
            { kind: 'p', text: 'Layar langkah pertama menampilkan tahap yang sedang berjalan dan log langsung:' },
            {
              kind: 'list',
              items: [
                'Membaca aturan robots.txt situs itu. Kalau situs melarang alat otomatis, Bystep berhenti.',
                'Membuka halaman yang kamu masukkan, lalu memilih sampai 12 halaman penting (harga, fitur, produk, cara kerja, integrasi, FAQ…) dari navigasi, sitemap, dan llms.txt.',
                'Membaca halaman satu per satu dengan jeda, sebagai BystepBot.',
                'Mengambil tangkapan layar sampai 4 halaman di browser terisolasi; halaman yang butuh JavaScript juga dibaca di sini.',
                'AI membaca semuanya dan menyusun hasil bedah.',
              ],
            },
            { kind: 'note', tone: 'ok', title: 'Boleh ditinggal', text: 'Prosesnya tetap berjalan dan hasilnya tersimpan di rencana. Buka lagi kapan saja dari riwayat rencana.' },
          ],
        },
        {
          title: 'Baca hasil bedahnya',
          blocks: [
            { kind: 'p', text: 'Hasilnya dikelompokkan: Produk (untuk siapa, masalah yang diselesaikan, nilai jual, model bisnis), Fitur, Alur pengguna, Harga, Model data (dugaan), Teknologi terdeteksi, Desain, Navigasi utama, Tangkapan layar, Peluang untuk versimu, Hal yang perlu diwaspadai, Yang tidak terlihat dari luar, Draf ide versimu, dan Yang akan ditanyakan di wawancara.' },
            {
              kind: 'table',
              head: ['Label fitur', 'Artinya'],
              rows: [
                ['terlihat', 'dikutip dari halaman yang dibaca; kutipannya dicek benar-benar ada di halaman itu'],
                ['dugaan', 'kesimpulan AI yang tidak terlihat langsung, misalnya layar di balik login atau model data'],
              ],
            },
            { kind: 'p', text: 'Salin laporan menyalin seluruh hasil sebagai Markdown. Begitu bedah selesai, draf ide versimu menjadi ide rencana, dan judul sementara "Bedah <domain>" diganti judul baru.' },
          ],
        },
        {
          title: 'Lanjut ke wawancara',
          blocks: [
            { kind: 'p', text: 'Tekan Lanjut ke wawancara. Di mode developer, langkah berikutnya adalah pilihan teknologi; di atasnya tampil teknologi yang dipakai situs acuan, sekadar referensi — kamu tidak harus memakai yang sama. Di langkah pertanyaan ada kartu Website acuan; tombol Lihat hasil bedah membuka laporannya lagi.' },
            { kind: 'p', text: 'Wawancara memakai hasil bedah sebagai fakta: apa yang dilakukan situs itu tidak ditanyakan lagi. Putaran pertama biasanya berisi Fitur versi pertama (pilih dari fitur situs acuan), untuk siapa versimu, pembeda utama, monetisasi dibanding harga acuan, dan platform. Mode sederhana tetap satu putaran berisi 3 pertanyaan; pertanyaan ketiga menawarkan fitur situs acuan dengan bahasa sehari-hari.' },
          ],
        },
        {
          title: 'PRD dan build seperti biasa',
          blocks: [
            { kind: 'p', text: 'PRD ditulis dari jawabanmu, bukan dari daftar fitur situs acuan. Bagian 1 mendapat subbagian Produk acuan: situs mana yang menjadi rujukan fungsional (bukan afiliasi dan bukan salinan), apa yang dipertahankan, apa yang dibuat berbeda, dan apa yang sengaja ditinggalkan. Fitur yang kamu buang masuk Bukan tujuan. PRD tidak memakai nama merek situs acuan dan tidak memuat gambar atau tautan dari situs itu.' },
            { kind: 'p', text: 'Setelah kamu membaca PRD, Susun fitur & task berjalan seperti biasa, lalu build lewat jalur mana pun (A, B, C, atau Team Build). Bystep Agent di halaman review PRD juga membaca ringkasan hasil bedah.' },
          ],
        },
        {
          title: 'Kalau bedahnya gagal',
          blocks: [
            {
              kind: 'table',
              head: ['Yang terjadi', 'Kenapa', 'Lakukan ini'],
              rows: [
                ['Ditolak sebelum mulai', 'alamat IP, localhost, jaringan internal, port selain 80/443; situs bank, dompet digital, atau pembayaran; domain militer; halaman login, checkout, atau pembayaran', 'masukkan halaman utama situs publik'],
                ['robots.txt melarang', 'pemilik situs menutup halaman itu untuk alat otomatis; robots.txt yang error dianggap melarang semua', 'Ganti URL, atau Lanjut tanpa bedah'],
                ['Content-Signal: ai-input=no', 'pemilik situs melarang isinya dipakai sebagai input AI', 'Lanjut tanpa bedah dan ceritakan idemu sendiri'],
                ['Di balik login atau proteksi bot', 'halaman butuh masuk, atau muncul tantangan bot/captcha — Bystep tidak menembusnya', 'masukkan halaman utama atau halaman pemasaran situsnya'],
                ['Situs tidak tersedia, terlalu lama, server dimulai ulang, AI gagal', 'gangguan sementara', 'Ulangi'],
                ['Situs pemerintah (.go.id)', 'dibaca dalam mode ringan: 3 halaman, jeda lebih panjang, tanpa tangkapan layar', 'hasilnya tetap bisa dipakai'],
              ],
            },
            { kind: 'p', text: 'Saat gagal selalu ada Ganti URL dan Lanjut tanpa bedah (tulis idemu sendiri, minimal 20 karakter, lalu masuk wawancara biasa); Ulangi muncul bila penyebabnya sementara.' },
          ],
        },
      ],
      outro: [
        { kind: 'note', tone: 'info', title: 'Batas harian', text: 'Gratis 3 bedah per 24 jam, paket berbayar 12, admin tanpa batas. Yang dihitung hanya bedah yang sampai ke langkah AI (ada rem tambahan bila terlalu sering mencoba). Maksimal 2 bedah berjalan bersamaan per akun. Menulis PRD tetap memakai jatah PRD seperti biasa.' },
      ],
      limits: {
        title: 'Batas jujur bedah website',
        items: [
          'Hanya halaman publik tanpa login: layar di dalam aplikasi mereka (dasbor, pengaturan) tidak terlihat dan muncul sebagai "dugaan" atau pertanyaan wawancara.',
          'Maksimal 12 halaman dan 4 tangkapan layar per bedah; situs yang sangat bergantung pada JavaScript bisa terbaca sebagian.',
          'Hasil bedah adalah inspirasi, bukan salinan: jangan meniru merek, logo, teks, gambar, atau tampilan khas situs lain.',
          'Tangkapan layar dan teks halaman yang dibaca dihapus setelah 7 hari; ringkasan bedah tetap tersimpan di rencana.',
          'Situs yang menolak lewat robots.txt atau Content-Signal, situs bank dan pembayaran, serta halaman login dan checkout tidak bisa dibedah.',
        ],
      },
    },

    otomatis: {
      overline: 'Jalur A',
      title: 'Bangunkan untuk saya',
      lead: 'Bystep yang mengerjakan langkahnya di komputer Bystep. Kamu hanya membaca, mencoba, dan menyetujui. Tidak ada yang perlu dipasang.',
      steps: [
        {
          title: 'Nyalakan mode sederhana',
          blocks: [
            { kind: 'p', text: 'Saat perkenalan pilih "Saya bukan programmer", atau nyalakan kapan saja di Pengaturan → Nyalakan mode sederhana. Semua tampilan berganti ke bahasa sehari-hari.' },
          ],
        },
        {
          title: 'Ceritakan idemu, baca rencananya',
          blocks: [
            { kind: 'p', text: 'Ikuti Bagian 1 di atas. Di mode sederhana rencananya pendek (maksimal sekitar 15 langkah) dan tahap pertama selalu bernama "Versi pertama yang bisa dipakai".' },
          ],
        },
        {
          title: 'Di layar "Rencanamu siap", pilih Bangunkan untuk saya',
          blocks: [
            { kind: 'p', text: 'Tiga pintu muncul: Bangunkan untuk saya, Didampingi, dan Mandiri. Pilih yang pertama.' },
            { kind: 'note', tone: 'warn', title: 'Dibuka bertahap', text: 'Jalur otomatis dibuka bertahap untuk peserta awal. Kalau belum tersedia untuk akunmu, tombolnya berbunyi Daftar tunggu dan kamu dikabari lewat email. Semua langkah lain di tutorial ini tetap bisa dipakai.' },
          ],
        },
        {
          title: 'Tekan Bangunkan untuk saya di halaman Bangun',
          blocks: [
            { kind: 'p', text: 'Halaman Bangun menunjukkan "Langkah n dari m" dan kalimat apa yang sedang dikerjakan. Kamu tidak perlu menunggu di depan layar — tutup saja, nanti dikabari.' },
            { kind: 'p', text: 'Di kartu Bangun dengan kamu bisa memilih siapa yang membayar: jatah langkah Bystep, Kunci AI-mu sendiri, atau Komputer saya (Jalur C).' },
          ],
        },
        {
          title: 'Coba dulu di HP-mu',
          blocks: [
            { kind: 'p', text: 'Setiap tahap selesai, tombol Buka aplikasinya memberi versi percobaan yang bisa dibuka di HP. Kalau cocok, tekan Lanjut. Kalau ada yang salah, tulis apa adanya: "yang ini salah, seharusnya …".' },
          ],
        },
        {
          title: 'Kalau macet',
          blocks: [
            { kind: 'p', text: 'Bystep mencoba memperbaiki sendiri sampai dua kali, lalu berhenti dan menjelaskan dengan bahasa biasa. Pilihanmu: coba lagi langkah ini, kembali ke versi sebelumnya, lewati langkah, atau Minta ditinjau manusia lewat halaman Bantuan.' },
            { kind: 'note', tone: 'ok', title: 'Langkah gagal tidak memotong jatah', text: 'Jatah hanya terpakai untuk langkah yang benar-benar dikerjakan sampai selesai.' },
          ],
        },
        {
          title: 'Terbitkan',
          blocks: [
            { kind: 'p', text: 'Halaman Terbitkan menjalankan Pemeriksaan keamanan lalu memberi tautan yang bisa dibuka siapa saja. Setelah itu tersedia Perbarui yang online, Riwayat versi (Kembalikan versi), Unduh salinan (ZIP), dan panduan Pasang di layar utama HP.' },
          ],
        },
      ],
      limits: {
        title: 'Batas jujur jalur ini',
        items: [
          'Hasilnya web-app yang bisa dipasang di layar utama HP (PWA), bukan aplikasi App Store/Play.',
          'Domain sendiri belum tersedia; alamatnya masih di bawah bystep.dev.',
          'Langganan Claude/ChatGPT-mu tidak bisa dipakai di server Bystep. Bisa, kalau dijalankan di komputermu sendiri — lihat Jalur C.',
          'Jalur otomatis masih dibuka bertahap; kalau belum dapat akses, ada daftar tunggu.',
        ],
      },
    },

    mandiri: {
      overline: 'Jalur B',
      title: 'Mandiri dengan CLI',
      lead: 'Agen kodingmu sendiri yang bekerja. Bystep memberi satu task per permintaan, lalu menolak menutupnya sampai buktinya lulus.',
      intro: [
        { kind: 'p', text: 'Prasyarat: berada di folder proyek Git, punya akses jaringan, dan Node.js 18 atau lebih baru.' },
      ],
      steps: [
        {
          title: 'Pasang CLI',
          blocks: [
            { kind: 'p', text: 'Pasang CLI 0.7.0 dari unduhan versi tetap berikut, lalu gunakan perintah bystep. Paket di npm dapat tertinggal dari versi unduhan Bystep:' },
            { kind: 'code', lines: CMD.installCli },
            { kind: 'p', text: 'Ingin tahu semua perintah tanpa menebak? CLI menerbitkan manifest mesin:' },
            { kind: 'code', lines: CMD.help },
          ],
        },
        {
          title: 'Masuk, hubungkan folder, pasang skill',
          blocks: [
            { kind: 'p', text: 'Ganti <workspaceId> dan <planId> dengan ID workspace dan proyek yang akan dikerjakan. Keduanya disimpan agar perintah tugas berikutnya memakai proyek yang tepat.' },
            { kind: 'code', lines: CMD.connect },
            { kind: 'p', text: 'login memakai alur perangkat: kode muncul di terminal, kamu mengonfirmasinya di browser (berlaku 10 menit). Bisa juga langsung dengan token: login --token bs_… dari Pengaturan → API key.' },
            { kind: 'p', text: 'connect menulis .bystep/config.json berisi id saja — aman di-commit. init memasang skill Bystep, hook penjaga, dan subagent ke agen yang terdeteksi (Claude Code, Cursor, Codex, OpenCode, AGENTS.md).' },
          ],
        },
        {
          title: 'Periksa kesiapan',
          blocks: [
            { kind: 'code', lines: CMD.doctor },
            { kind: 'p', text: 'doctor memeriksa Node, alamat API, token, dan sambungan repo. doctor --repo memberi skor kesiapan proyek untuk agen, bekerja offline.' },
          ],
        },
        {
          title: 'Jalankan loop',
          blocks: [
            { kind: 'code', lines: CMD.loop },
            { kind: 'p', text: 'Server yang memilih task berikutnya — agen tidak pernah melihat seluruh backlog. task next mengembalikan Task Packet: deskripsi, kriteria terima, file yang dimiliki task, file yang tidak boleh disentuh, konvensi, perintah verifikasi, dan keputusan proyek.' },
            { kind: 'p', text: 'task complete menjalankan verify lebih dulu dan menolak kalau buktinya belum lulus. Gagal dua kali? Laporkan apa adanya:' },
            { kind: 'code', lines: CMD.fail },
          ],
        },
        {
          title: 'Pilih mode berhenti',
          blocks: [
            { kind: 'p', text: 'Bawaannya Autopilot. Ubah lewat papan task (tombol Eksekusi) atau dari terminal:' },
            { kind: 'code', lines: CMD.planExec },
            {
              kind: 'table',
              head: ['Mode', 'Berhenti kapan'],
              rows: [
                ['Autopilot (bawaan)', 'tidak pernah menunggu persetujuan; berhenti saat selesai, gagal, atau tiga kali verifikasi merah'],
                ['Checkpoint', 'tiap kali kelompok fase + lapisan selesai'],
                ['Strict', 'setelah setiap task'],
              ],
            },
          ],
        },
        {
          title: 'Setujui gerbang tahap',
          blocks: [
            { kind: 'p', text: 'Saat gerbang menunggu, task next keluar dengan kode 3 dan tidak memberi task. Persetujuan adalah keputusan manusia — agen tidak boleh menekan sendiri.' },
            { kind: 'code', lines: CMD.approve },
            {
              kind: 'note',
              tone: 'warn',
              title: 'Sebutkan lapisannya',
              text: 'Gerbang checkpoint tersimpan per fase DAN lapisan. Tanpa --layer, CLI memakai "all" yang tidak cocok dengan gerbang mana pun sehingga tampak tidak terjadi apa-apa. Pakai --layer frontend atau --layer backend; baris petunjuk di keluaran CLI sudah menyebut lapisan yang benar.',
            },
            { kind: 'p', text: 'Mau mengembalikan sebagian pekerjaan dengan catatan?' },
            { kind: 'code', lines: CMD.approveReturn },
            { kind: 'p', text: 'Mode Strict disetujui per task, dan itu hanya bisa dilakukan dari halaman web atau MCP hosted — bukan dari CLI.' },
          ],
        },
        {
          title: 'Kirim ringkasan codebase (opsional tapi berguna)',
          blocks: [
            { kind: 'code', lines: CMD.sync },
            { kind: 'p', text: 'sync memindai repo, menghormati .gitignore, menolak .env dan secret, dan hanya mengunggah path, ukuran, hash, dan bahasa. Agenmu menulis ringkasan singkat per file secara lokal; hanya ringkasannya yang naik. Dari situ Bystep membangun Wiki, dan rencana kedua di workspace itu terbuka.' },
          ],
        },
        {
          title: 'Sudah punya spec di tempat lain?',
          blocks: [
            { kind: 'code', lines: CMD.importSpec },
            { kind: 'p', text: 'Impor mendukung Spec Kit, OpenSpec, backlog.md, dan Task Master.' },
          ],
        },
      ],
      outro: [
        {
          kind: 'table',
          head: ['Kode keluar', 'Artinya'],
          rows: [
            ['0', 'sukses'],
            ['1', 'error runtime/API, atau verifikasi gagal'],
            ['2', 'input salah (id kurang, penggunaan keliru)'],
            ['3', 'gerbang tahap menunggu persetujuan manusia'],
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          title: 'Aturan loop untuk agen',
          text: 'Kerjakan satu task; jangan menyentuh file di luar ownedFiles; patuhi doNotTouch, konvensi, dan blok aturan proyek di packet; complete hanya setelah verify hijau; kalau gagal dua kali, fail dengan alasan — jangan memaksa override.',
        },
      ],
      limits: {
        title: 'Batas jujur jalur ini',
        items: [
          'Tidak ada tombol Verify di web. Bukti hanya masuk dari CLI atau agen.',
          'Verifikator GitHub Actions bisa dipilih lewat CLI/API, tetapi di antarmuka web masih dimatikan dan ditandai segera hadir.',
          'Mode Strict tidak bisa disetujui dari CLI maupun MCP stdio.',
          'docs/cli.md di repo sudah tertinggal; pakai bystep --llms atau /api/schema sebagai acuan perintah.',
        ],
      },
    },

    komputer: {
      overline: 'Jalur C',
      title: 'Bangun di komputer sendiri (bystep serve)',
      lead: 'Komputermu yang menjalankan agen dengan langganan yang sudah kamu bayar. Bystep tetap memilih langkah, menyimpan bukti, dan menyediakan tombol — tetapi tidak pernah menyentuh loginmu.',
      steps: [
        {
          title: 'Pasang Node.js dan agenmu',
          blocks: [
            { kind: 'p', text: 'Pasang Node.js LTS dari nodejs.org. Lalu pasang agen pilihanmu dan masuk sendiri di komputer itu — Bystep tidak pernah menyalin login agen.' },
            { kind: 'code', caption: 'Claude', lines: CMD.installAgentClaude },
            { kind: 'code', caption: 'ChatGPT / Codex', lines: CMD.installAgentCodex },
          ],
        },
        {
          title: 'Periksa kesiapan komputer',
          blocks: [
            { kind: 'code', lines: CMD.serveFirst },
            { kind: 'p', text: 'serve --doctor menjawab dengan bahasa sehari-hari: versi Node, git, agen yang ditemukan beserta versinya, dari mana kredensialnya kelihatannya berasal, versi protokol, berapa langkah paralel yang disanggupi komputer ini, dan sisa ruang disk.' },
            { kind: 'note', tone: 'info', title: 'Asal kredensial itu dugaan', text: 'Keterangan "langganan" atau "kunci API" disimpulkan dari berkas dan variabel yang ada di komputer, bukan bukti identitas akun.' },
          ],
        },
        {
          title: 'Atau sambungkan dengan kode pairing (tanpa login)',
          blocks: [
            { kind: 'p', text: 'Di halaman Komputer saya (bystep.dev/serve), setelah masuk, tekan Tampilkan kode pairing. Muncul kode 8 karakter, kode QR, dan perintahnya. Di komputer tujuan:' },
            { kind: 'code', lines: CMD.servePair },
            { kind: 'p', text: 'Kode berlaku sekali dan hanya 10 menit. Komputer menerima kunci miliknya sendiri, berlaku 90 hari dan diperbarui otomatis bila tersisa kurang dari 7 hari. Kode salah, kedaluwarsa, atau sudah terpakai menghasilkan pesan yang sama — minta kode baru.' },
          ],
        },
        {
          title: 'Arahkan proyek ke komputer itu',
          blocks: [
            { kind: 'p', text: 'Di Bystep buka halaman Bangun → kartu Bangun dengan → Komputer saya, lalu pilih komputernya. Mulai sekarang tombol Bangunkan untuk saya mengirim langkah ke komputer itu, dan jatah langkah Bystep tidak terpakai.' },
            { kind: 'p', text: 'Biarkan jendela serve terbuka. "Coba dulu di HP-mu" tetap bekerja selama komputer menyala dan tersambung.' },
          ],
        },
        {
          title: 'Setel sesuai seleramu',
          blocks: [
            { kind: 'code', lines: CMD.serveOptions },
            {
              kind: 'table',
              head: ['Opsi', 'Gunanya'],
              rows: [
                ['--parallel <n>', 'batas bagian tim yang dikerjakan sekaligus di komputer ini (1–8). Tanpa opsi ini, komputer mengikuti tim sampai 4.'],
                ['--runs-per-hour <n>', 'rem opsional: maksimal n run per jam. Bawaannya tanpa batas.'],
                ['--once', 'kerjakan satu langkah lalu keluar.'],
                ['--dir <path>', 'folder proyek yang dipakai (bawaan: ~/.bystep/projects/<workspace>).'],
                ['--no-listen', 'matikan listener lokal; agen lalu hanya melapor lewat keluarannya.'],
                ['--yolo', 'izinkan agen menjalankan perintah apa pun tanpa bertanya — hanya di komputer yang kamu percaya.'],
              ],
            },
          ],
        },
        {
          title: 'Biarkan berjalan di latar',
          blocks: [
            { kind: 'code', lines: CMD.service },
            { kind: 'p', text: 'service install memasang serve sebagai layanan yang menyala lagi sendiri bila berhenti (Linux systemd, macOS launchd, Windows Task Scheduler). Masuk atau lakukan pairing dulu sebelum memasang layanan — token tidak ikut disalin ke unit layanan.' },
          ],
        },
        {
          title: 'Perbarui CLI',
          blocks: [
            { kind: 'code', lines: CMD.update },
            { kind: 'p', text: 'update tanpa opsi hanya memeriksa. --apply mengunduh, mencocokkan ukuran dan sha256, lalu memasang. Setelah itu mulai ulang serve atau layanannya.' },
          ],
        },
        {
          title: 'Agen apa saja yang bisa dipakai',
          blocks: [
            {
              kind: 'table',
              head: ['Agen', 'Di komputer sendiri', 'Di cloud'],
              rows: [
                ['Claude Code', 'ya', 'ya'],
                ['Codex CLI', 'ya', 'ya (wajib pakai kunci API sendiri)'],
                ['Cursor Agent', 'ya', 'tidak'],
                ['Gemini CLI', 'ya', 'tidak'],
                ['opencode', 'ya', 'tidak'],
                ['Skrip sendiri (custom)', 'ya', 'tidak'],
                ['GitHub Copilot CLI', 'terdaftar, belum diaktifkan', 'tidak'],
              ],
            },
            { kind: 'p', text: 'Agen hanya bisa dipakai kalau programnya memang terpasang dan sudah login sendiri di komputermu. Daftar resmi yang selalu terbaru ada di /api/agents (perlu login).' },
            { kind: 'p', text: 'Mau memakai skrip buatan sendiri? Taruh berkas bisa-jalan di .bystep/agents/, lalu pilih saat memulai tim agent:' },
            { kind: 'code', lines: CMD.customAgent },
            { kind: 'p', text: 'Bystep mengisi BYSTEP_PROMPT (atau BYSTEP_PROMPT_FILE), BYSTEP_RUN_ID, BYSTEP_TASK_REF, BYSTEP_API_URL, dan BYSTEP_TOKEN yang hanya berlaku untuk langkah itu. Hasilnya dibaca dari JSON di stdout atau berkas .bystep/out/<runId>.md.' },
          ],
        },
      ],
      limits: {
        title: 'Batas jujur jalur ini',
        items: [
          'Login langganan Claude/ChatGPT tidak boleh diunggah ke Bystep. Menyimpan rahasia yang isinya mirip token langganan akan ditolak; pakai kunci API dari konsol penyedia, atau jalankan agen di komputermu sendiri.',
          'Layanan latar dan penyimpanan kunci di macOS dan Windows belum diverifikasi di mesin nyata; Linux sudah.',
          'Manifest pembaruan tidak ditandatangani; yang dicocokkan adalah ukuran dan sha256 lewat HTTPS.',
          'Bystep Desktop baru tersedia untuk Linux x64 dan belum ditandatangani; eksekusi di Windows dimatikan. Web tetap produk utamanya.',
          'Paket di npm bisa tertinggal dari unduhan di bystep.dev — cek dengan --version.',
        ],
      },
    },

    'team-build': {
      overline: 'Bersama developer',
      title: 'Team Build: build bersama tim 2–10 orang',
      lead: 'Founder memegang tujuan dan prioritas; setiap tugas punya penanggung jawab manusia. Developer bisa memakai AI dan login masing-masing, sementara Bystep menyimpan pembagian kerja, konteks, bukti, review, dan catatan rilis.',
      intro: [
        { kind: 'p', text: 'Bab ini untuk kolaborasi antarorang. Bab Tim agent membahas eksekusi beberapa agen yang dikelola Bystep. Kamu tetap dapat memilih alat yang cocok untuk setiap tugas, tetapi klaim Team Build tidak menjalankan agen otomatis.' },
        { kind: 'note', tone: 'info', title: 'Mulai dengan satu tugas kecil', text: 'Untuk tim dua orang, developer dapat mengerjakan satu tugas dan founder menjadi reviewer bila mampu menilai kriterianya. Jika founder yang mengerjakan, tentukan orang lain sebagai reviewer. Gunakan AI untuk membantu, sementara tanggung jawab tetap melekat pada akun manusia.' },
      ],
      steps: [
        {
          title: 'Undang tim dan pilih proyek',
          blocks: [
            { kind: 'p', text: 'Buka workspace → Tim / Build bersama tim. Pemilik membuka Pengaturan tim untuk mengundang developer. Anggota perlu menerima undangan dengan akun masing-masing sebelum bekerja. Pilih proyek di bagian atas; proyek draft juga dapat dipakai.' },
            { kind: 'p', text: 'Undangan memberikan akses kolaborasi sesuai peran. Akses komputer, secret, pembayaran, dan deployment pemilik memerlukan pengaturan tersendiri.' },
          ],
        },
        {
          title: 'Ubah PRD, brief, atau codebase menjadi lingkup yang disepakati',
          blocks: [
            { kind: 'table', head: ['Titik awal', 'Langkah di Lingkup proyek'], rows: [
              ['Sudah punya PRD', 'Tempel teks atau impor Markdown/teks, lalu buat preview kebutuhan.'],
              ['Belum punya PRD', 'Pilih brief dan tulis tujuan serta kebutuhan awal. Tinjau asumsi sebelum menyetujui tugas.'],
              ['Sudah punya codebase', 'Hubungkan repo lewat CLI dan jalankan bystep sync --plan <planId>. Pilih codebase untuk meninjau baseline file, commit, dan lingkup.'],
              ['Menambah fitur pada proyek berjalan', 'Pilih rencana tambahan; putuskan apakah kebutuhan memakai tugas lama, menjadi tugas tambahan, atau dikeluarkan.'],
            ] },
            { kind: 'p', text: 'Pemilik meninjau sumber dan cakupan ekstraksi, memperbaiki kebutuhan, memilih perintah verifikasi yang relevan, lalu menerapkan pilihan yang disetujui. Preview tidak menjalankan perintah. File yang terlihat dalam manifest belum membuktikan fitur itu berfungsi; periksa bagian teramati, terverifikasi, dan belum diketahui.' },
            { kind: 'p', text: 'Untuk PDF atau format lain, gunakan teks hasil ekstraksi dan periksa cakupannya. Perubahan lingkup/kriteria setelah pekerjaan dimulai dapat membatalkan konteks, bukti, atau persetujuan lama; beri tahu developer untuk mengambil konteks baru.' },
          ],
        },
        {
          title: 'Tentukan pemilik tugas dan reviewer',
          blocks: [
            { kind: 'p', text: 'Pada kartu tugas, tekan Tentukan pemilik. Pilih penanggung jawab, reviewer teknis, dan bila diperlukan reviewer produk. Gunakan kebijakan Teknis atau Teknis dan produk sesuai keputusan tim, serta tulis alasan pembagiannya. Reviewer harus berbeda dari penanggung jawab tugas.' },
            { kind: 'p', text: 'Penugasan menyatakan siapa yang bertanggung jawab. Klaim menyatakan siapa yang sedang mengerjakan sekarang. Mulai dengan tugas yang batasnya jelas; koordinasikan perubahan pada file yang sama melalui branch, PR, dan handoff.' },
          ],
        },
        {
          title: 'Ambil tugas, lalu berikan konteks ke AI sendiri',
          blocks: [
            { kind: 'p', text: 'Di komputer setiap developer, gunakan Node.js 22 atau lebih baru dan jalankan perintah dari repo proyek. Ganti <workspaceId>, <planId>, dan <ref> dengan ID workspace, ID proyek, serta referensi tugas yang sebenarnya. Gunakan kedua ID saat menghubungkan repo baru:' },
            { kind: 'code', lines: CMD.installCli },
            { kind: 'code', lines: CMD.teamConnect },
            { kind: 'code', lines: CMD.teamClaim },
            { kind: 'p', text: 'Ganti codex dengan nama alat yang kamu pakai, atau manual untuk pekerjaan tanpa AI. Setelah klaim berhasil, ambil konteks dan berikan kepada alat pilihanmu. Jalankan AI sendiri dengan login pribadinya. Nama agent pada klaim hanya mencatat alat; Bystep tidak menyalin login atau langganan AI. Jika memakai anggaran harian atau resource bersama, gunakan contoh klaim dengan resources.json pada langkah anggaran di bawah.' },
            { kind: 'note', tone: 'warn', title: 'Satu klaim aktif per tugas', text: 'Klaim berlaku 15 menit secara default. Perpanjang selama bekerja sebelum kedaluwarsa. Jangan mulai mengedit ketika tugas masih diklaim orang lain. Simpan .bystep/team-claims/ di .gitignore; setiap developer memakai state klaim sendiri. Untuk berpindah CLI/MCP, gunakan repo yang sama.' },
          ],
        },
        {
          title: 'Verifikasi revisi, perbarui konteks, lalu laporkan',
          blocks: [
            { kind: 'p', text: 'Selesaikan perubahan pada revisi Git yang jelas, jalankan pemeriksaan yang disepakati, dan pastikan bukti merujuk commit yang sama. Ambil ulang konteks setelah verifikasi mencatat revisi terbaru. Jika sumber, aturan, keputusan, atau scope berubah, tinjau dampaknya dan perbaiki pekerjaan sebelum melaporkan:' },
            { kind: 'code', lines: CMD.teamVerify },
            { kind: 'p', text: 'Buat report.json. Semua nilai <…> di contoh ini harus diganti: acceptanceHash dari konteks terbaru, SHA commit penuh, ringkasan hasil yang sebenarnya, dan ID bukti hasil verifikasi. Jangan mengirim teks placeholder atau mengaku tes lulus sebelum dijalankan.' },
            { kind: 'code', caption: 'report.json — contoh untuk pekerjaan kode', lines: CMD.teamReportJson },
            { kind: 'code', lines: CMD.teamReport },
            { kind: 'p', text: 'Gunakan status blocked atau failed beserta alasan bila belum siap. Untuk tugas yang seluruh kriterianya manual, ajukan hasil kepada reviewer independen; tugas itu tidak diberi label tes otomatis terverifikasi. Kriteria kode tetap memerlukan bukti lulus yang sesuai.' },
            { kind: 'note', tone: 'info', title: 'Jika laporan ditolak', text: 'Periksa masa berlaku klaim, penugasan, konteks, dan revisi. Hasil sesi lama ditolak setelah klaim dilepas, diganti, kedaluwarsa, atau dicabut. Untuk mengulang permintaan identik, simpan idempotencyKey hasil CLI dan gunakan --key dengan nilai yang sama; payload berbeda memerlukan key baru.' },
          ],
        },
        {
          title: 'Minta review independen atas hasil yang sama',
          blocks: [
            { kind: 'p', text: 'Reviewer membuka Review saya, memeriksa kriteria, perubahan kode, hasil tes, dan bukti. Berikan keputusan terima atau minta perubahan dengan catatan. Jika kebijakan meminta review teknis dan produk, kedua review harus terpenuhi.' },
            { kind: 'p', text: 'Review terikat pada kriteria, commit, dan revisi PR yang ditinjau. Perubahan berikutnya membutuhkan bukti serta review yang sesuai versi terbaru. AI boleh membantu reviewer, tetapi keputusan melalui CLI atau MCP tetap memakai identitas manusia yang memberi instruksi.' },
            { kind: 'table', head: ['Status', 'Artinya'], rows: [
              ['Terverifikasi', 'Pemeriksaan mesin untuk kriteria dan revisi terkait lulus.'],
              ['Diterima', 'Kebijakan review untuk hasil terkini sudah terpenuhi.'],
              ['Override', 'Pemilik mencatat pengecualian; tetap dibedakan dari hasil yang diterima atau terverifikasi.'],
              ['Dirilis', 'Pemilik sudah mencatat deployment dari hasil yang diterima.'],
            ] },
          ],
        },
        {
          title: 'Catat rilis setelah deployment benar-benar selesai',
          blocks: [
            { kind: 'p', text: 'Setelah hasil diterima, lakukan deployment menggunakan proses yang disepakati tim dan periksa aplikasinya. Pemilik lalu menekan Catat rilis pada tugas, mengisi environment serta URL deployment. Catatan mengikat rilis ke kriteria dan revisi yang diterima, lalu muncul di riwayat.' },
            { kind: 'note', tone: 'info', title: 'Catatan rilis bukan tombol deploy', text: 'Catat rilis tidak mengirim kode ke hosting atau memberikan akses akun deployment. Bila merge menghasilkan SHA berbeda, perbarui bukti dan review untuk revisi hasil merge sebelum mencatat rilisnya.' },
          ],
        },
        {
          title: 'Serahkan konteks saat berganti orang atau alat',
          blocks: [
            { kind: 'p', text: 'Sebelum meninggalkan pekerjaan, tulis handoff.json berisi goal, completed, acceptanceHash terbaru, commitHash bila tersedia, dan nextSteps (daftar langkah). Tambahkan toUserId, branch, evidenceIds, checks, risks, atau decisions bila relevan. Handoff mengakhiri klaim dan menugaskan tugas kepada toUserId; jika dihilangkan, tugas kembali tanpa penanggung jawab. Penerima harus anggota yang diterima dan bukan reviewer tugas tersebut.' },
            { kind: 'code', lines: CMD.teamHandoff },
            { kind: 'p', text: 'Atau, jika hanya ingin berhenti tanpa handoff, buat reason.json berisi alasan, misalnya {"reason":"Berhenti untuk hari ini"}, lalu gunakan perintah berikut sebagai pengganti handoff:' },
            { kind: 'code', lines: CMD.teamRelinquish },
            { kind: 'p', text: 'Hentikan editor/agen eksternal sendiri. Penerima mengklaim tugas dan mengambil konteks baru dengan akunnya. Handoff tidak memindahkan sesi percakapan native model atau login AI.' },
          ],
        },
        {
          title: 'Pantau kemajuan dari Ringkasan',
          blocks: [
            { kind: 'p', text: 'Gunakan Tugas saya untuk pekerjaan sendiri, Review saya untuk antrean review, dan filter terhambat untuk masalah yang perlu ditindaklanjuti. Tab Ringkasan memuat milestone, blocker, sesi kedaluwarsa, pembaruan untuk akunmu, dan riwayat rilis.' },
            { kind: 'p', text: 'Tentukan tugas serta tanggal target milestone, lalu pantau jumlah hasil diterima dan rilis yang dicatat. Ekspor CSV membantu evaluasi aktivitas dan waktu review. Biaya yang belum diketahui dan data yang belum tersedia tetap perlu ditindaklanjuti; jumlah tugas saja tidak membuktikan kualitas hasil.' },
          ],
        },
        {
          title: 'Hubungkan PR dan pemeriksaan GitHub bila diperlukan',
          blocks: [
            { kind: 'p', text: 'Di Repositori & PR, pemilik menyimpan token GitHub dengan izin baca metadata, PR, checks, dan status commit untuk repo terkait. Daftarkan repo dan nama check wajib yang persis, lalu Perbarui dari GitHub dan hubungkan PR ke tugas. Satu tugas dapat membutuhkan beberapa PR dari repo berbeda dengan SHA masing-masing.' },
            { kind: 'p', text: 'CI dipercaya dari snapshot terautentikasi untuk revisi yang tepat. Label ci yang dikirim sendiri bukan bukti CI tepercaya. Bila PR atau merge berubah, lakukan refresh serta review ulang. Webhook bertanda tangan perlu konfigurasi administrator tersendiri; mendaftarkan repo tidak otomatis memasangnya. Refresh manual tetap tersedia.' },
          ],
        },
        {
          title: 'Atur komputer dan anggaran hanya saat perlu berbagi',
          blocks: [
            { kind: 'p', text: 'Alur paling sederhana memakai komputer dan AI masing-masing. Jika memakai komputer anggota lain, daftarkan komputer melalui bystep serve; pemilik memberi grant untuk anggota, agent, dan waktu berlaku tertentu di AI & anggaran. Klaim dengan --file resources.json dapat menyebut executorId dan executorOwnerId yang diizinkan. Grant tidak otomatis menjalankan AI jarak jauh.' },
            { kind: 'p', text: 'Pembayar memberi grant terpisah serta anggaran harian. Saat klaim, payerId dan requestedBudgetMicros menentukan pembayar serta reservasi sesi; 1 USD = 1.000.000 micros. Jika anggaran harian diaktifkan, deklarasikan reservasi sebelum mulai. Pemakaian aktual dilaporkan terpisah.' },
            { kind: 'code', lines: CMD.teamResourceClaim },
            { kind: 'p', text: 'MCP 0.5.0 belum menyediakan parameter grant atau reservasi pada team_claim. Untuk kasus ini, buat klaim melalui CLI dengan resources.json dahulu, lalu lanjutkan MCP dari repo yang sama agar memakai klaim lokal tersebut.' },
            { kind: 'note', tone: 'warn', title: 'Belum diketahui tetap belum diketahui', text: 'Biaya langganan/pribadi yang tidak dilaporkan tidak dihitung nol. Reservasi tetap ditahan sampai pembayar merekonsiliasi biaya dengan catatan. Batas Bystep mengatur reservasi sesi, sementara pemakaian AI di luar sesi mengikuti akun provider. Grant dicabut, komputer offline, atau runtime berubah dapat menolak laporan; pencabutan tidak menjamin proses eksternal telah berhenti.' },
          ],
        },
        {
          title: 'Impor issue GitLab tanpa menghilangkan keputusan lokal',
          blocks: [
            { kind: 'p', text: 'Di Integrasi issue, pemilik menyimpan token GitLab.com dengan izin read_api, memasukkan group/project, dan menentukan apakah judul/deskripsi mengikuti GitLab atau Bystep. Buat preview, pilih issue, selesaikan konflik perubahan lokal dan remote, lalu terapkan.' },
            { kind: 'p', text: 'Import dan refresh membaca issue GitLab.com. Status pengerjaan serta review Bystep tetap terpisah dari status issue; perubahan tugas tidak otomatis ditulis balik ke GitLab. Menonaktifkan koneksi mempertahankan tugas yang sudah dibuat. Linear, Jira, dan GitLab self-hosted belum tersedia dalam alur ini.' },
          ],
        },
      ],
      limits: {
        title: 'Batas yang perlu disepakati tim',
        items: [
          'Tunggu eksekusi runner/tim agent di workspace selesai atau direkonsiliasi sebelum membuat klaim pribadi. Generasi rencana yang masih berjalan juga perlu diselesaikan lebih dahulu.',
          'Klaim melindungi koordinasi satu tugas; pembagian file, branch, merge, dan proses deployment tetap membutuhkan disiplin tim.',
          'Konteks baru harus dibaca dan diterapkan. Mengambil ulang konteks saja tidak membuktikan AI telah memahami perubahan atau hasilnya benar.',
          'Untuk alur AI tanpa mengetik CLI, pasang MCP 0.5.0 pada bab MCP. Urutannya: team_tasks → team_claim → team_context → pengerjaan → task_verify → team_context → team_report; perpanjang dengan team_heartbeat. Untuk anggaran atau resource bersama, ganti team_claim dengan klaim CLI berparameter seperti langkah anggaran.',
        ],
      },
    },

    tim: {
      overline: 'Mode lanjutan',
      title: 'Tim agent: beberapa langkah sekaligus',
      lead: 'Satu langkah selalu dikerjakan satu per satu. Tim agent mengerjakan beberapa langkah yang tidak saling bersentuhan secara bersamaan, tiap bagian di folder sendiri.',
      steps: [
        {
          title: 'Nyalakan dari halaman Bangun',
          blocks: [
            { kind: 'p', text: 'Buka panel Kerjakan dengan tim agent, nyalakan sakelar Kerjakan beberapa sekaligus, lalu tekan Mulai tim agent. Sakelar ini hanya muncul kalau paketmu mengizinkan lebih dari satu.' },
            { kind: 'p', text: 'Di Pengaturan lanjutan kamu menentukan jumlah bagian sekaligus serta batas token, batas biaya USD, dan batas menit. Perkiraan biaya muncul di bawah tombol sebelum kamu menekannya.' },
          ],
        },
        {
          title: 'Atau kendalikan dari terminal',
          blocks: [{ kind: 'code', lines: CMD.workflow }],
        },
        {
          title: 'Pahami aturan mainnya',
          blocks: [
            {
              kind: 'list',
              items: [
                'Tiap langkah bekerja di folder sendiri; langkah yang menyentuh berkas sama dikerjakan bergiliran.',
                'Satu gelombang berisi maksimal 4 langkah yang file miliknya tidak bertabrakan. Task tanpa file milik dianggap menyentuh semuanya, jadi dikerjakan sendirian.',
                'Langkah baru dianggap selesai bila bukti gabungan lulus; gerbang tahap tetap menunggu persetujuanmu.',
                'Pesan ke tim dibaca pada tugas berikutnya — tidak memotong agen yang sedang berjalan.',
                'Perintah berhenti baru tuntas setelah semua proses terbukti berhenti.',
              ],
            },
            { kind: 'p', text: 'Di komputer sendiri, --parallel membatasi berapa bagian yang dikerjakan sekaligus di mesin itu.' },
          ],
        },
        {
          title: 'Kalau terjadi bentrok saat digabung',
          blocks: [
            { kind: 'p', text: 'Tim berhenti, Bystep membuat task "Bentrok gabung: <ref>" dan item Inbox "Bentrok — perlu kamu". Task Perbaiki selalu didahulukan. Bentrok tidak pernah diselesaikan otomatis.' },
            { kind: 'p', text: 'Tim yang berhenti karena batas pemakaian tampil sebagai "Dihentikan karena batas …" di Inbox dan di halaman Biaya.' },
          ],
        },
        {
          title: 'Kalau berhenti karena batas atau komputer mati',
          blocks: [
            { kind: 'p', text: 'Inbox bisa menawarkan Lanjutkan di cloud atau Lanjutkan di komputer kamu, lengkap dengan perkiraan biaya. Ini tidak pernah otomatis: kamu harus menekan dan mengonfirmasi.' },
            { kind: 'p', text: 'Di pengaturan workspace kamu bisa memilih Tanyakan dulu (bawaan) atau Jangan pernah pindah.' },
          ],
        },
      ],
      limits: {
        title: 'Batas jujur mode ini',
        items: [
          'Permintaan melebihi batas paket ditolak dengan pesan jelas, bukan dipotong diam-diam.',
          'Membeli tambahan agent bersamaan belum dijual.',
          'Tim agent di cloud hanya jalan bila server mengaktifkannya; kalau tidak, pakai komputer sendiri.',
          'Batalkan giliran belum mendukung sesi tim di komputermu — pakai Kembalikan versi.',
        ],
      },
    },

    kendali: {
      overline: 'Kendali mutu',
      title: 'Gerbang, Pemeriksa, izin perintah, dan cara mundur',
      lead: 'Semua ini opsional dan mati secara bawaan. Nyalakan yang kamu butuhkan di papan task, tombol Eksekusi.',
      steps: [
        {
          title: 'Mode berhenti dan verifikator',
          blocks: [
            {
              kind: 'table',
              head: ['Setelan', 'Pilihan', 'Catatan'],
              rows: [
                ['Mode', 'Autopilot · Checkpoint · Strict', 'bawaan Autopilot; di Autopilot banner checkpoint tidak pernah muncul'],
                ['Verifikator', 'Lokal · Penilai Bystep · GitHub Actions', 'bawaan Lokal; GitHub Actions masih dimatikan di antarmuka'],
                ['Pemeriksa', 'Mati · Otomatis · Selalu', 'bawaan Mati'],
                ['Gerbang', 'Critical · Major', 'temuan setara gerbang menahan hasil'],
                ['Persetujuan perintah', 'Mati · Berisiko · Semua', 'bawaan Mati; hanya di komputer sendiri'],
              ],
            },
            { kind: 'p', text: 'Penilai Bystep hanya bekerja setelah pemeriksaan lokal lulus, dan ia boleh menurunkan status lulus jadi gagal. Kalau jatahnya habis, pemeriksaan dilewati dan hasil lokal tetap berlaku.' },
          ],
        },
        {
          title: 'Pemeriksa (agen baca-saja)',
          blocks: [
            { kind: 'p', text: 'Setelah hasil gabungan lulus uji, satu agen tambahan membaca perubahan tanpa mengubah berkas dan memberi temuan berlabel Critical, Major, atau Minor. Tidak ada tombol "jalankan Pemeriksa" — ia berjalan sendiri sesuai setelan.' },
            { kind: 'p', text: 'Temuan setara gerbang menghentikan tim dan muncul di Inbox. Dari panel Temuan Pemeriksa kamu bisa menekan Perbaiki semua (yang membuat task Perbaiki per pemilik berkas), Periksa ulang, atau Periksa dari awal.' },
            { kind: 'note', tone: 'info', title: 'Tiga hal berbeda dengan nama mirip', text: 'Pemeriksa = agen baca-saja yang memberi temuan. Penilai Bystep = verifikator yang memutuskan lulus/gagal satu langkah. Minta ditinjau = tinjauan manusia berbayar di halaman Bantuan.' },
          ],
        },
        {
          title: 'Persetujuan perintah',
          blocks: [
            { kind: 'p', text: 'Pada setelan Berisiko, perintah yang jelas aman berjalan sendiri (misalnya git status, pnpm test, ls). Perintah lain menunggu kamu menekan Izinkan atau Tolak di Inbox, dan kamu bisa mencentang Ingat untuk proyek ini.' },
            { kind: 'note', tone: 'warn', title: 'Hanya Claude Code', text: 'Hanya Claude Code yang bisa bertanya per perintah. Codex, Gemini, Cursor, opencode, dan skrip sendiri tetap berada di sandbox-nya dan tercatat sebagai approval_unsupported. Setelan ini juga hanya berlaku di komputer sendiri, bukan di cloud.' },
          ],
        },
        {
          title: 'Kartu Keputusan',
          blocks: [
            { kind: 'p', text: 'Satu pertanyaan, dua sampai tiga pilihan beserta akibatnya. Pilihanmu menjadi keputusan proyek yang dibaca semua agen berikutnya, dan tiap kartu hanya bisa dipilih sekali.' },
            { kind: 'p', text: 'Tombol Periksa rencana mencari pertentangan di dalam rencana dan memakai 1 pesan chat dari jatahmu tiap kali ditekan.' },
            { kind: 'p', text: 'Keputusan juga bisa dicatat dari terminal:' },
            { kind: 'code', lines: CMD.decision },
          ],
        },
        {
          title: 'Lihat apa yang sedang dikerjakan',
          blocks: [
            {
              kind: 'list',
              items: [
                'Jejak kerja: apa yang dilakukan agen dalam bahasa sehari-hari — pesan, membaca/mengubah/menjalankan, berkas yang berubah, perintah beserta keluarannya.',
                'Log teknis: tampilan terminal baca-saja. Tidak bisa dipakai mengetik perintah ke agen.',
                'Mengapa status ini?: status efektif, aturan yang memutuskannya, dan sinyal terakhir. Agen tanpa sinyal ditandai jelas — diam bukan berarti sedang bekerja.',
                'Lensa Giliran di papan task mengelompokkan ulang jadi AI sedang jalan, Perlu kamu, Siap, dan Selesai. Di lensa ini seret-lepas dimatikan.',
              ],
            },
          ],
        },
        {
          title: 'Kalau perlu mundur',
          blocks: [
            { kind: 'p', text: 'Batalkan langkah ini mengembalikan berkas ke keadaan sebelum satu giliran agen. Berkas yang sudah berubah lagi sesudahnya tidak ditimpa.' },
            {
              kind: 'note',
              tone: 'warn',
              title: 'Yang tidak ikut dikembalikan',
              text: 'Hanya berkas di disk yang dikembalikan. Status task, bukti, dan versi tersimpan tidak berubah — verifikasi ulang setelahnya. Komputer dan folder proyek yang sama harus menyala; berkas di atas 5 MB, symlink, dan submodule tidak bisa dikembalikan; sesi tim di komputer sendiri belum didukung.',
            },
            { kind: 'p', text: 'Kalau batalkan giliran tidak bisa, pakai Kembalikan versi — mengembalikan versi aplikasi tanpa membangun ulang.' },
          ],
        },
        {
          title: 'Inbox dan notifikasi',
          blocks: [
            { kind: 'p', text: 'Inbox mengumpulkan semua yang menunggumu: gerbang tahap, izin perintah, langkah gagal, bentrok gabung, temuan Pemeriksa, dan Kartu Keputusan. Tiap baris punya tombol Buka dan Mengapa?.' },
            { kind: 'p', text: 'Notifikasi dibedakan antara "perlu perhatian" dan "selesai", dan bisa dikirim lewat email, Telegram, atau Discord. Pesan yang gagal terkirim dicatat alasannya di pengaturan notifikasi.' },
          ],
        },
      ],
    },

    mcp: {
      overline: 'Integrasi',
      title: 'Pakai Bystep lewat MCP',
      lead: 'Kalau agenmu mendukung MCP, kamu bisa memakai Bystep tanpa mengetik perintah sama sekali.',
      steps: [
        {
          title: 'MCP stdio di Claude Code atau Cursor',
          blocks: [
            { kind: 'p', text: 'Pasang MCP 0.5.0 dari unduhan versi tetap. CLI dipasang terpisah seperti di Jalur B; jalankan bystep login dan hubungkan repo lebih dahulu:' },
            { kind: 'code', lines: CMD.installMcp },
            { kind: 'p', text: 'Tambahkan executable bystep-mcp ke konfigurasi agenmu. Isi BYSTEP_REPO dan BYSTEP_REPO_ROOT dengan path absolut yang sama ke repo yang sudah dihubungkan; keduanya diperlukan agar konteks dan verifikasi menggunakan folder yang sama:' },
            { kind: 'code', caption: '.mcp.json / mcp.json', lines: CMD.mcpStdio },
            { kind: 'p', text: 'Dari direktori repo yang sudah dihubungkan, di Claude Code bisa juga:' },
            { kind: 'code', lines: CMD.mcpClaudeAdd },
            { kind: 'p', text: 'Server memakai login CLI lokal yang sudah ada; id rencana diambil dari .bystep/config.json. Pastikan bystep-mcp ada di PATH aplikasi, atau gunakan path absolut executable. CLI dan MCP untuk Team Build harus menunjuk repo yang sama; jangan bagikan file .bystep/team-claims/.' },
          ],
        },
        {
          title: 'MCP stdio di Codex',
          blocks: [{ kind: 'code', lines: CMD.mcpCodex }],
        },
        {
          title: 'MCP hosted untuk Claude.ai, ChatGPT, atau Cursor',
          blocks: [
            { kind: 'p', text: 'Tambahkan konektor Streamable HTTP dengan kunci API Bystep dari Pengaturan → API key:' },
            { kind: 'code', lines: CMD.mcpHosted },
            { kind: 'p', text: 'Versi hosted memakai bahasa sehari-hari: daftar rencana, status rencana, jalankan langkah berikutnya, status jalannya, tautan coba di HP, setujui tahap, dan eskalasi saat macet.' },
          ],
        },
        {
          title: 'Tool yang tersedia',
          blocks: [
            {
              kind: 'table',
              head: ['Kelompok', 'Tool'],
              rows: [
                ['Rencana & langkah (stdio)', 'plan_get · plan_list · task_next · task_packet · task_start · task_verify · task_complete · task_fail · task_evidence_get · phase_approve · wave_next · sync_status'],
                ['Team Build (stdio)', 'team_tasks · team_claim · team_context · team_heartbeat · team_assign · team_report · team_handoff · team_relinquish · team_review · team_release'],
                ['Tim agent (keduanya)', 'workflow_list · workflow_get · workflow_start · workflow_stop · workflow_resume · workflow_message'],
                ['Kendali (keduanya)', 'review_submit · approval_list · approval_answer · decision_card_list · decision_card_choose · decision_list · decision_add · rules_list · state_get'],
                ['Khusus hosted', 'list_plans · plan_status · run_next · run_status · preview_url · approve_stage · escalate · task_packet'],
              ],
            },
            { kind: 'note', tone: 'warn', title: 'Hanya atas perintah pengguna', text: 'Menyetujui tahap, menjawab izin perintah, memilih Kartu Keputusan, serta memulai atau menghentikan tim agent tidak boleh dilakukan agen atas inisiatif sendiri.' },
          ],
        },
      ],
    },

    kolaborasi: {
      overline: 'Bersama orang lain',
      title: 'Design Room, berbagi, dan portal klien',
      lead: 'Sebelum ada rencana, rumuskan dulu bersama. Sesudah ada rencana, tunjukkan kemajuannya tanpa memberi akses mengubah.',
      steps: [
        {
          title: 'Buka Design Room',
          blocks: [
            { kind: 'p', text: 'Dari beranda pilih Mulai dari Design Room, lalu Ruang baru. Tentukan judul, template sesi, bahasa ruang, apakah kartu anonim, apakah suara disembunyikan, dan berapa suara per orang.' },
          ],
        },
        {
          title: 'Undang peserta',
          blocks: [
            { kind: 'p', text: 'Tekan Buat tautan. Siapa pun yang punya tautan itu bisa bergabung hanya dengan mengisi nama — tanpa akun. Tautan berlaku 30 hari, dan membuat tautan baru menghanguskan yang lama.' },
          ],
        },
        {
          title: 'Jalani enam langkahnya',
          blocks: [
            { kind: 'p', text: 'Masalah → Pengguna → Asumsi → Ide → Pilih → Rumuskan. Tiap peserta menambah kartu (dan boleh membangun di atas kartu orang lain), lalu menandai Saya selesai langkah ini.' },
            { kind: 'p', text: 'Ide tetap tersembunyi sampai pemimpin sesi menekan Buka semua ide — butuh minimal tiga ide. Setelah itu ide dikelompokkan otomatis dan sesi lanjut ke voting. Suara tetap buta sampai voting ditutup.' },
            { kind: 'p', text: 'Panel AI fasilitator bisa merangkum, menantang, mengkritik lewat persona, mengelompokkan ide, dan menyusun hipotesis. AI tidak pernah ikut memilih.' },
          ],
        },
        {
          title: 'Ubah hasilnya jadi rencana',
          blocks: [
            { kind: 'p', text: 'Di langkah terakhir, pemimpin sesi menekan Rumuskan & buat plan. Bystep membuat rencana lengkap dengan jawaban wizard dan jejak asal-usulnya, mulai menulis PRD, lalu menutup ruang. Laporan sesi tersedia dalam Markdown untuk semua peserta.' },
          ],
        },
        {
          title: 'Bagikan rencana sebagai tautan baca-saja',
          blocks: [
            { kind: 'p', text: 'Tombol Bagikan di header proyek memberi tautan publik. Pengunjung melihat PRD, daftar fitur per fase, kartu Bukti Selesai (hanya angka), dan fase yang sudah kamu setujui. Judul task dan keluaran tidak pernah ikut.' },
            { kind: 'note', tone: 'warn', title: 'Tautan langsung dibuat saat dialog dibuka', text: 'Tautan berbagi tidak punya kata sandi, tidak kedaluwarsa, dan saat ini belum bisa dicabut. Jangan membagikan rencana yang isinya rahasia.' },
          ],
        },
        {
          title: 'Undang klien ke portal',
          blocks: [
            { kind: 'p', text: 'Di kartu Tim, masukkan email dan pilih peran Klien, lalu tekan Undang dan kirim tautannya. Undangan terikat email: akun yang menerima harus memakai email yang sama.' },
            { kind: 'p', text: 'Klien melihat kemajuan per fase, statistik bukti, estimasi vs aktual, dan linimasa persetujuan. Satu-satunya tombol yang bisa mereka tekan adalah Setujui fase, dengan catatan opsional. Peran Klien tidak memakan kuota anggota tim.' },
          ],
        },
      ],
      limits: {
        title: 'Batas jujur',
        items: [
          'Klien tidak bisa berkomentar dan tidak melihat Kartu Keputusan.',
          'Mode ruang yang serba-langsung (timer per langkah, indikator kursor) belum ada; yang ada pembaruan berkala.',
          'Sertifikat peserta belum tersedia.',
        ],
      },
    },

    terbitkan: {
      overline: 'Sesudah jadi',
      title: 'Terbitkan, rawat, dan awasi',
      lead: 'Rencana bukan tujuan akhirnya. Ini yang kamu pakai setelah langkah-langkahnya mulai selesai.',
      steps: [
        {
          title: 'Terbitkan aplikasinya',
          blocks: [
            { kind: 'p', text: 'Halaman Terbitkan menjalankan Pemeriksaan keamanan, lalu memberi tautan publik. Setelah terbit tersedia Perbarui yang online, Riwayat versi, Tidurkan dulu, Salin tautan, dan Unduh salinan (ZIP).' },
            { kind: 'p', text: 'Menerbitkan membutuhkan proyek yang memang bisa dijalankan (punya package.json).' },
          ],
        },
        {
          title: 'Jaga dokumentasi tetap hidup',
          blocks: [
            { kind: 'p', text: 'Jalankan sync codebase secara berkala. Bystep membangun Wiki dari ringkasan file, dan Wiki itulah yang membuka rencana berikutnya di workspace yang sama.' },
            { kind: 'p', text: 'Di tab Wiki ada Pindai drift untuk membandingkan PRD dengan kode yang benar-benar ada; hasilnya menjadi usulan yang kamu Terapkan atau Tolak. Pemindaian drift adalah fitur Pro.' },
          ],
        },
        {
          title: 'Awasi biaya dan kesiapan',
          blocks: [
            {
              kind: 'list',
              items: [
                'Halaman Biaya: token, durasi, dan biaya per task; bisa diekspor CSV.',
                'Halaman Kesiapan proyek: skor kesiapan dan laporan bukti yang bisa diunduh.',
                'Halaman Agent readiness publik: tempel URL repo GitHub publik mana pun untuk mendapat skor 0–100 dan sebelas pemeriksaan, tanpa login.',
                'Halaman Benchmark publik: pass rate nyata per agen dan per jenis kriteria, bukan ilustrasi.',
              ],
            },
          ],
        },
        {
          title: 'Ekspor ke mana pun',
          blocks: [
            { kind: 'p', text: 'Tombol Mulai bangun menyediakan: unduh PRD (Markdown), unduh ZIP, spec Kiro, Spec Kit, OpenSpec, Backlog.md, Task Master, Claude Code Tasks, GitHub Issues, Linear, dan prompt siap tempel untuk agen AI.' },
          ],
        },
      ],
    },

    paket: {
      overline: 'Paket',
      title: 'Kuota, paket, dan cara bayar',
      lead: 'Angka di bawah ini benar saat tutorial ditulis. Halaman Harga selalu menjadi sumber yang berlaku.',
      intro: [
        {
          kind: 'table',
          head: ['Paket', 'Harga', 'PRD/bulan', 'Pesan agent/bulan'],
          rows: [
            ['Free', 'Rp 0', '1', '5'],
            ['Starter', 'Rp 99.000', '5', '60'],
            ['Pro', 'Rp 249.000', '15', '120'],
            ['Builder', 'Rp 299.000', '3', '40'],
            ['Studio', 'Rp 699.000', '40', '350'],
          ],
        },
        { kind: 'p', text: 'Builder ditujukan untuk jalur otomatis: 20 langkah terverifikasi dan 2 aplikasi online per bulan. Ada juga paket Kampus dan Facilitator.' },
      ],
      steps: [
        {
          title: 'Beli atau perpanjang',
          blocks: [
            { kind: 'p', text: 'Buka Harga, pilih paket, lalu selesaikan pembayaran. Pembayaran rupiah lewat Pakasir (QRIS dan Virtual Account bank besar); pembayaran USD lewat Paddle yang sudah termasuk pajak. Voucher hanya berlaku untuk pembayaran rupiah.' },
          ],
        },
        {
          title: 'Tambah jatah tanpa ganti paket',
          blocks: [
            {
              kind: 'table',
              head: ['Top-up', 'Isi', 'Harga'],
              rows: [
                ['PRD', '5 kredit', 'Rp 39.000'],
                ['Pesan chat', '100 pesan', 'Rp 89.000'],
                ['Langkah Runner', '10 langkah', 'Rp 99.000'],
                ['Pemeriksa', '25 pemeriksaan', 'Rp 79.000'],
              ],
            },
            { kind: 'p', text: 'Kredit top-up tidak kedaluwarsa dan dipakai setelah jatah bulanan paketmu habis.' },
          ],
        },
        {
          title: 'Pakai kunci AI sendiri',
          blocks: [
            { kind: 'p', text: 'Di Pengaturan → Koneksi AI-ku kamu bisa menyimpan kunci API Anthropic, OpenAI, OpenRouter, atau layanan lain. Uji koneksi memastikan kuncinya bekerja. Maksimal 10 koneksi, dan biayanya ditagih langsung ke akun penyediamu, bukan ke Bystep.' },
            { kind: 'note', tone: 'warn', title: 'Kunci API, bukan login akun', text: 'Nilai yang terlihat seperti token langganan akan ditolak. Kalau yang kamu punya adalah langganan Claude atau ChatGPT, pakailah Jalur C: jalankan di komputermu sendiri.' },
          ],
        },
      ],
      limits: {
        title: 'Yang belum bisa dibeli lewat checkout',
        items: [
          'Studio masih daftar tunggu dan dijual per workspace, belum lewat checkout.',
          'Kampus ditagih lewat formulir kemitraan di halaman Campus.',
          'Konsultasi belum menerima pembayaran di situs; permintaan dibalas lewat email.',
          'Tambahan agent bersamaan belum dijual.',
        ],
      },
    },

    masalah: {
      overline: 'Kalau tersendat',
      title: 'Masalah umum dan cara mengatasinya',
      lead: 'Pesan yang paling sering muncul, apa artinya, dan apa yang harus dilakukan.',
      intro: [
        {
          kind: 'table',
          head: ['Yang kamu lihat', 'Artinya', 'Lakukan ini'],
          rows: [
            ['evidence_required saat menandai selesai', 'belum ada bukti yang lulus untuk task itu', 'jalankan task verify, atau tandai selesai lewat override dengan alasan'],
            ['task next keluar dengan kode 3', 'gerbang tahap menunggu persetujuan manusia', 'setujui di web, atau task approve <fase> --layer frontend|backend'],
            ['task approve dijalankan tapi tidak terjadi apa-apa', 'tanpa --layer, CLI memakai "all" yang tidak cocok dengan gerbang mana pun', 'ulangi dengan --layer frontend atau --layer backend'],
            ['402 saat menulis PRD atau mengirim chat', 'jatah bulanan habis', 'tunggu bulan berikutnya, beli top-up, atau naikkan paket'],
            ['Kredit langkah habis', 'jatah langkah Runner bulan ini habis', 'beli top-up langkah, atau pindah ke Komputer saya'],
            ['Kode pairing ditolak', 'kode salah, kedaluwarsa (10 menit), atau sudah terpakai', 'tampilkan kode baru di halaman Komputer saya'],
            ['Komputer tampil offline padahal serve jalan', 'pairing baru selesai, atau jendela serve tertutup', 'biarkan serve berjalan; cek dengan serve --doctor'],
            ['Ini terlihat seperti token langganan', 'yang ditempel adalah login akun, bukan kunci API', 'pakai kunci API dari konsol penyedia, atau jalankan di komputer sendiri'],
            ['Paket kamu mengizinkan n agent bersamaan', 'permintaan tim melebihi batas paket', 'turunkan jumlahnya; permintaan tidak pernah dipotong diam-diam'],
            ['Tim berhenti dengan temuan Pemeriksa', 'ada temuan setara gerbang', 'tekan Perbaiki semua, atau Periksa ulang setelah diperbaiki'],
            ['Bentrok — perlu kamu', 'dua bagian tim mengubah berkas yang sama', 'kerjakan task Bentrok gabung yang dibuat otomatis'],
            ['Wiki belum siap', 'rencana kedua terkunci sampai wiki ada', 'jalankan sync codebase lebih dulu'],
            ['Impor issue diminta terlalu sering', 'satu permintaan per 5 menit per workspace', 'tunggu sebentar lalu ulangi'],
            ['Batas bedah harian tercapai', 'jatah bedah website 24 jam untuk paketmu sudah terpakai', 'tunggu, atau pilih Dari ide untuk menulis idemu sendiri'],
            ['Bedah website berhenti di robots.txt atau Content-Signal', 'pemilik situs menolak alat otomatis atau input AI', 'Ganti URL, atau Lanjut tanpa bedah (lihat Bagian 1b)'],
          ],
        },
        { kind: 'note', tone: 'info', title: 'Masih buntu?', text: 'Halaman Bantuan di dalam proyek menyediakan tinjauan manusia berbayar dengan tenggat 24 jam. Untuk pertanyaan umum, pakai halaman Support.' },
      ],
    },

    referensi: {
      overline: 'Referensi',
      title: 'Referensi cepat',
      lead: 'Semua perintah yang ada, dikelompokkan. Sumber yang selalu terbaru: bystep --llms dan bystep.dev/api/schema.',
      intro: [
        {
          kind: 'table',
          head: ['Kelompok', 'Perintah'],
          rows: [
            ['Akun & folder', 'login · connect · init · doctor · status · whoami · workspace list'],
            ['Rencana', 'plan list · plan get · plan exec · import <path> --from speckit|openspec|backlog|taskmaster'],
            ['Langkah', 'task next · task list · task start · task verify · task complete · task fail · task packet · task guard · task approve · wave next'],
            ['Kode', 'sync'],
            ['Team Build', 'team tasks · team claim · team context · team heartbeat · team assign · team report · team handoff · team relinquish · team review · team release'],
            ['Tim agent', 'workflow list · workflow start · workflow show · workflow stop · workflow resume · workflow message'],
            ['Keputusan', 'decision list · decision add · decision replace'],
            ['Komputer sendiri', 'serve (--doctor, --pair, --parallel, --runs-per-hour, --listen/--no-listen, --once, --dir, --yolo, --no-keychain) · service install|status|uninstall · update'],
            ['Di dalam langkah Bystep', 'report · review submit · hooks <adapter> <event> (dipasang otomatis)'],
          ],
        },
        { kind: 'p', text: 'Saat kamu menjadi agen di dalam sebuah langkah Bystep, laporkan keadaan dan kirim temuan seperti ini:' },
        { kind: 'code', lines: CMD.report },
        { kind: 'p', text: 'Untuk mengambil satu gelombang berisi maksimal empat task yang tidak bertabrakan:' },
        { kind: 'code', lines: CMD.wave },
        {
          kind: 'table',
          head: ['Halaman', 'Isinya'],
          rows: [
            ['/mulai', 'tiga pintu, penjelasan singkat'],
            ['/plan?flow=website', 'Bedah website: situs acuan → hasil bedah → wawancara → PRD'],
            ['/bot', 'tentang BystepBot: user-agent, aturan yang dipatuhi, cara menolak'],
            ['/otomatis', 'jalur untuk yang bukan programmer'],
            ['/tutorial#team-build', 'alur kolaborasi founder dan developer dengan AI masing-masing'],
            ['/serve', 'sambungkan komputer, kode pairing, QR'],
            ['/docs', 'ringkasan cara kerja dan bagian MCP hosted'],
            ['/integrations', 'format impor/ekspor dan konektor MCP'],
            ['/readiness', 'nilai kesiapan repo GitHub publik'],
            ['/benchmark', 'pass rate publik'],
            ['/templates dan /playbooks', 'rencana jadi dan resep usaha'],
            ['/kebijakan-penyedia', 'kebijakan tiap vendor AI per cara pakai'],
            ['/pricing', 'harga dan batas yang berlaku'],
            ['/api/schema', 'skema mesin: semua perintah, tool MCP, dan Task Packet'],
          ],
        },
      ],
    },
  },
  closing: {
    title: 'Siap mencoba?',
    lead: 'Rencana pertama gratis, tanpa kartu kredit. Mulai dari idemu, atau ambil salah satu template yang sudah terbukti.',
    primary: 'Mulai gratis',
    secondary: 'Lihat template',
  },
}
